import { Injectable } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';

// Adaptador de fecha para el datepicker de Material (typeForm="date"): permite
// escribir la fecha directamente en el input como día/mes/año, en vez de solo
// poder elegirla del calendario. NativeDateAdapter por sí solo no entiende ese
// formato al escribirlo (interpreta el primer número como mes) y por eso el
// input se dejaba en solo lectura.
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value !== 'string' || !value.trim()) {
      return value instanceof Date ? value : null;
    }
    const match = value.trim().match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})$/);
    if (!match) {
      return null;
    }
    const day = Number(match[1]);
    const month = Number(match[2]) - 1;
    let year = Number(match[3]);
    if (year < 100) {
      year += year < 50 ? 2000 : 1900;
    }
    const date = new Date(year, month, day);
    // Si el día no existe en ese mes (ej. 31/02), Date corrige la fecha al mes
    // siguiente en silencio — mejor rechazarla que guardar una fecha distinta
    // a la escrita.
    return date.getMonth() === month ? date : null;
  }

  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      return `${day}/${month}/${date.getFullYear()}`;
    }
    return super.format(date, displayFormat);
  }
}

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'input',
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
